import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { Transformations } from "../layouts";

import { DOCO_ROUTES, ApplicationRoute, ROUTES } from "../utils";

const menu = "doco";
export const DocumentRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        path={[`${DOCO_ROUTES.TRANSFORMATIONS}`]}
        component={Transformations}
      />
      <Redirect to={ROUTES.HOME} />
    </Switch>
  );
};
